<template>
  <div class="paginated-processed-email-component">
    <div class="filters">
      Per pagina
      <a-select :disabled="loading" :value="showPerPage['processed']" v-on:change="onPerPageChange">
        <a-select-option v-for="(option, index) in perPageOptions" :key="index" :value="option">
          {{ option }}
        </a-select-option>
      </a-select>

      <overview-filter-component :filter-sender="true" :filter-date-range="true"
                                 :filter-key-word="true" :disable-filters="loading"
                                 @filter-request="getFilteredEmails($event)"/>
    </div>

    <div class="panel-body">
      <laravel-pagination class="no-margin" v-if="showPagination" :data="currentRequestData"
                          @pagination-change-page="loadPage"/>

      <div class="pull-right">
        <a-button v-on:click="onUnmatchAllClick" type="danger" :disabled="!hasUnlinkableSelection">
          <link-variant-off-icon></link-variant-off-icon>
          {{
            selectedUnlinkableEmails.length > 0 ? selectedUnlinkableEmails.length + ' ontkoppelen' : 'Ontkoppel'
          }}
        </a-button>
        <a-button v-on:click="onUnprocessAllClick" type="primary" :disabled="!hasSelection">
          <check-icon></check-icon>
          {{
            selectedEmails.length > 0 ? selectedEmails.length + ' markeren als onverwerkt' : 'Markeren als onverwerkt'
          }}
        </a-button>
      </div>
    </div>

    <table class="table table-striped">
      <thead>
      <tr v-if="hasEmails">
        <th class="compact half-padding">
          <a-checkbox ref="globalCheckbox" :checked="allSelected" :indeterminate="indeterminate"
                      @change="onSelectAllChanged"></a-checkbox>
        </th>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="subject" @change="onOrderByChange"> E-mail</order-by>
        </th>
        <th class="compact">
          <!--          FIXME: make customer sortable by last name -->
          <!--          <order-by :order="order" :select="orderBy" value="customer_id" @change="onOrderByChange">-->
          Klant
          <!--          </order-by>-->
        </th>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="date" @change="onOrderByChange"> Ontvangen op</order-by>
        </th>
        <th class="compact">
          <!--          FIXME: make processedBy sortable by last name -->
          <!--          <order-by :order="order" :select="orderBy" value="processed_by_id" @change="onOrderByChange"> -->
          Verwerkt door
          <!--          </order-by>-->
        </th>
        <th class="compact"></th>
      </tr>
      <tr v-if="!hasEmails && filterActive">
        <th class="compact"> Er zijn geen emails gevonden die voldoen aan de actieve filters.</th>
      </tr>
      </thead>

      <tbody>
      <RowComponent v-if="hasEmails && !loading" v-for="email in emails" :key="email.id" :email="email"
                    @onSelectionChanged="onSelectionChanged"
                    @onUnprocessed="onUnprocessed"></RowComponent>
      <tr v-if="loading">
        <td style="width: 100%;" class="text-center">De e-mails worden geladen...</td>
      </tr>
      </tbody>
    </table>

    <div v-if="!hasEmails && !loading && !filterActive" class="no-mail-today">
      Er zijn geen e-mails gevonden.
    </div>

    <div class="panel-body" v-if="showPagination">
      <laravel-pagination class="no-margin" :data="currentRequestData" @pagination-change-page="loadPage"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import emailModule from '~/modules/email/store';
import store from '~/store';
import emailApi from "~/api/email";
import RowComponent from "~/modules/email/components/ProcessedRowComponent";
import OverviewFilterComponent from "~/modules/email/components/OverviewFilterComponent";

export default {
  name: "PaginatedProcessedEmailComponent",
  components: {RowComponent, OverviewFilterComponent},
  props: {
    emailAccountId: {
      type: [String, Number],
      required: false,
      default: null
    },
    mailboxId: {
      type: [String, Number],
      required: false,
      default: null
    },
    perPage: {
      type: Number,
      default: 10,
    }
  },
  data() {
    return {
      perPageOptions: [5, 10, 15, 30, 50],
      loading: true,
      reloadTimeout: null,
      currentPage: null,
      currentRequestData: null,
      page: 1,
      orderBy: 'date',
      order: 'desc',
      filter: {},
      emails: [],
      allSelected: false,
    }
  },
  computed: {
    ...mapGetters('email', [
          'name',
          'showPerPage',
          'selectedEmails',
        ],
    ),
    indeterminate() {
      return this.allSelected === false && this.currentSelectionDiff !== this.emails.length && this.currentSelectionDiff > 0;
    },
    currentSelectionDiff() {
      return this.emails.filter(i => this.selectedEmails.findIndex(x => x.id === i.id) < 0).length;
    },
    hasSelection() {
      return this.selectedEmails.length > 0;
    },
    selectedUnlinkableEmails() {
      return this.selectedEmails.filter(email => typeof email.customer_id === "number");
    },
    hasUnlinkableSelection() {
      return this.selectedUnlinkableEmails.length > 0;
    },
    showPagination() {
      return !this.loading && this.hasEmails && this.hasPages;
    },
    hasEmails() {
      return this.emails.length > 0;
    },
    hasPages() {
      if (!this.loading && this.currentRequestData.meta !== null && typeof this.currentRequestData !== 'undefined'
          && this.currentRequestData.meta.pagination !== null
          && typeof this.currentRequestData.meta.pagination !== 'undefined') {
        return this.currentRequestData.meta.pagination.total_pages > 1;
      }
      return false;
    },
    filterInitialized() {
      return Object.keys(this.filter).length > 0;
    },
    filterActive() {
      if (Object.entries(this.filter)) {
        for (const [key, value] of Object.entries(this.filter)) {
          if (value !== null && value.length > 0) return true;
        }
      }
      return false;
    }
  },
  methods: {
    ...mapActions('email', [
      'setShowPerPage',
      'initialiseStore'
    ]),
    initEmails() {
      this.loadPage(this.page, true);
    },
    loadPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) return
      this.loading = true
      if (this.emailAccountId !== null) {
        this.loadEmailsFromEmailAccount(page)
      } else if (this.mailboxId !== null) {
        this.loadEmailsFromMailbox(page)
      }
    },
    loadEmailsFromEmailAccount(page) {
      emailApi.getPaginatedProcessedByEmailAccount(
          this.emailAccountId,
          page,
          this.showPerPage[this.location],
          this.orderBy,
          this.order,
          ['customer', 'user', 'processedBy'],
          this.filter,
      ).then(response => {
        this.currentRequestData = response
        this.emails = response.data
        this.currentPage = page
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt de e-mails op te halen.',
        })
      }).finally(() => {
        this.loading = false
      })
    },
    loadEmailsFromMailbox(page) {
      emailApi.getPaginatedProcessedByMailbox(
          this.mailboxId,
          page,
          this.showPerPage[this.location],
          this.orderBy,
          this.order,
          ['customer', 'user', 'processedBy'],
          this.filter,
      ).then(response => {
        this.currentRequestData = response
        this.emails = response.data
        this.currentPage = page
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt de e-mails op te halen.',
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onPerPageChange(value) {
      this.setShowPerPage({key: "processed", perPage: value});
      this.$nextTick(() => {
        this.loadPage(1, true);
      });
    },
    onOrderByChange(orderBy, order) {
      this.orderBy = orderBy;
      this.order = order;
      this.loadPage(this.currentPage, true);
    },
    getFilteredEmails(params) {
      this.filter = params;
      this.loadPage(this.page, true);
    },
    onSelectionChanged(email, selected, shiftKey) {
      if (selected === true) {
        this.selectEmail(email);
      } else {
        this.deselectEmail(email);
      }
    },
    onSelectAllChanged() {
      this.allSelected = !this.allSelected;

      for (let i in this.emails) {
        let email = this.emails[i];

        if (this.allSelected === true && this.selectedEmails.findIndex(x => x.id === email.id) < 0) {
          this.selectEmail(email);
        } else if (this.allSelected === false) {
          this.deselectEmail(email);
        }
      }
    },
    selectEmail(email) {
      this.selectedEmails.push(email);

      if (this.currentSelectionDiff === 0) {
        this.allSelected = true;
      }
    },
    selectEmails(emails) {
      for (let i in this.emails) {
        this.selectEmail(this.emails[i]);
      }
    },
    deselectEmail(email) {
      this.allSelected = false;

      this.selectedEmails.splice(this.selectedEmails.findIndex(x => x.id === email.id), 1);
    },
    deselectEmails(emails) {
      for (let i in this.emails) {
        this.deselectEmail(this.emails[i]);
      }
    },
    onUnmatchAllClick() {
      this.loading = true;

      emailApi.unmatchEmails(this._.map(this.selectedEmails, 'id')).then(() => {
        // trigger reload
        for (let i in this.selectedEmails) {
          this.selectedEmails[i].customer_id = null;
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde e-mails niet ontkoppelen',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    onUnprocessAllClick() {
      this.loading = true;
      emailApi.unprocessEmails(this._.map(this.selectedEmails, 'id')).then(response => {
        // trigger reload
        this.initEmails(this.page, true);
        this.deselectEmails(this.selectedEmails);
        // TODO remove when push notifications are set up for this count
        response.data.emailAccounts.forEach((emailAccount) => {
          this.processBadges('.badge.email-account-count[data-id="' + emailAccount.email_account_hashid + '"]', emailAccount.count)
        });
        // Total
        this.processBadges('.emails-panel-count', response.meta.count);
        this.processBadges('.total-email-count', response.meta.count);
      }).catch(error => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde e-mails niet verwerken',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    processBadges(badge, count) {
      let $badge = $(badge);
      if (count === 0) {
        $badge.addClass('hidden');
      } else {
        $badge.removeClass('hidden').text(count);
      }
    },
    onUnprocessed() {
      this.initEmails(this.currentPage, true);
    },
  },
  mounted() {
    if ((this.emailAccountId === null && this.mailboxId === null) ||
        (this.emailAccountId !== null && this.mailboxId !== null)) {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Een instelling staat verkeerd om de e-mails op te kunnen halen',
      });
    }
    if (this.perPageOptions.indexOf(this.perPage) === -1) {
      this.perPageOptions.push(this.perPage);
      this.perPageOptions.sort((a, b) => a - b);
    }
    this.initEmails();
  },
  created() {
    if (!store.hasModule('email')) {
      store.registerModule('email', emailModule)
    }

    this.initialiseStore({key: "processed", perPage: this.perPage});
  },
}
</script>

<style scoped>
.no-margin {
  margin: 0;
}

.filters {
  display: inline-block;
  margin: 1rem 0 0 1rem;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

.no-mail-today {
  padding: 0 10px 15px;
}
</style>
